import VueRouter from 'vue-router'

import App from './App'

import Landing from './components/Landing'
import Login from './components/Login'
import Access from './components/Access'
import Password from './components/Password'
import ForgotPassword from './components/ForgotPassword'
import ForgotPasswordToken from './components/ForgotPasswordToken'
import PrivacyPolicy from './components/PrivacyPolicy'

import auth from './services/auth'

function requireAuthAndCheckNotPassword(to, from, next) {
  if (!auth.user.authenticated) {
    next({
      path: '/innskraning'
    })
  } else {
    var payload = auth.getPayload()

    if (payload.change_password) {
      next({
        path: '/lykilord'
      })
    } else {
      next()
    }
  }
}

function skipIfAuthAndCheckPassword(to, from, next) {
  if (!auth.user.authenticated) {
    next()
  } else {
    var payload = auth.getPayload()

    if (payload.change_password) {
      next({
        path: '/lykilord'
      })
    } else {
      var callbackUrl = 'c' in to.query ? to.query.c : null
      var callbackSystem = 's' in to.query ? to.query.s : null
      var callbackSystem1 = 'c1' in to.query ? to.query.c1 : null
      var query = {}

      if (callbackUrl) {
        query.c = callbackUrl
      }
      if (callbackSystem) {
        query.s = callbackSystem
      }
      if (callbackSystem1) {
        query.c1 = callbackSystem1
      }

      next({
        path: '/adgangur',
        query: query
      })
    }
  }
}

function requireAuthAndCheckPassword(to, from, next) {
  if (!auth.user.authenticated) {
    next({
      path: '/innskraning'
    })
  } else {
    var payload = auth.getPayload()

    if (!payload.change_password) {
      next({
        path: '/adgangur'
      })
    } else {
      next()
    }
  }
}

const routes = [
  {
    path: '/',
    component: App,
    children: [
      { path: '/', component: Landing } /*, redirect: '/innskraning' */,
      {
        path: '/gleymt-lykilord',
        component: ForgotPassword,
        beforeEnter: skipIfAuthAndCheckPassword
      },
      {
        path: '/nytt-lykilord',
        component: ForgotPasswordToken,
        beforeEnter: skipIfAuthAndCheckPassword
      },
      {
        path: '/innskraning',
        component: Login,
        beforeEnter: skipIfAuthAndCheckPassword
      },
      {
        path: '/adgangur',
        component: Access,
        beforeEnter: requireAuthAndCheckNotPassword
      },
      {
        path: '/lykilord',
        component: Password,
        beforeEnter: requireAuthAndCheckPassword
      },
      {
        path: '/privacypolicy',
        component: PrivacyPolicy,
        beforeEnter: skipIfAuthAndCheckPassword
      },
      {
        path: '/utskra',
        beforeEnter(to, from, next) {
          auth.logout()
          next('/')
        }
      }
    ]
  }
]

// const routes = [
//   {
//     path: '/',
//     name: 'Home',
//     component: Home
//   },
//   {
//     path: '/about',
//     name: 'About',
//     // route level code-splitting
//     // this generates a separate chunk (about.[hash].js) for this route
//     // which is lazy-loaded when the route is visited.
//     component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
//   }
// ]

const router = new VueRouter({
  mode: 'history',
  routes
})

export default router
